import FileSave from 'file-saver';
import { useState } from 'react';

import { useAuth } from 'context/AuthProvider/AuthProvider';
import { useSnackbar } from 'context/SnackbarProvider/SnackbarProvider';
import { getAuthHeader } from 'utils/auth/getAuthHeader';
import { fetchData, FetchDataResponse } from 'utils/fetchData';

export const useDownloadFile = () => {
  const [isLoading, setIsLoading] = useState(false);
  const { setSnackbarInfo } = useSnackbar();
  const { getAccessToken } = useAuth();

  const downloadFile = async (url: string) => {
    const token = await getAccessToken();
    if (token) {
      try {
        setIsLoading(true);
        const result = (await fetchData(url, getAuthHeader(token))) as FetchDataResponse<any>;

        if (result.blob) {
          const filenameHeader = result.headers?.get('X-Filename');
          const fileName = filenameHeader ? filenameHeader : 'frame_monitoring.csv';
          FileSave.saveAs(result.blob, fileName);
        } else if (result.errorResponse) {
          // eslint-disable-next-line
          console.error(`Failed to download file: ${result.errorResponse.message}`);
          setSnackbarInfo({
            severity: 'error',
            open: true,
            content: {
              header: 'Failed to download file',
              message: 'If the issue persists please report it to our support team',
            },
          });
        }
      } catch (err) {
        const error = err as Error;

        setSnackbarInfo({
          severity: 'error',
          open: true,
          content: {
            header: 'Failed to download file',
            message: error.message,
          },
        });
        setIsLoading(false);
      }
      setIsLoading(false);
    }
  };

  return { downloadFile, isLoading };
};
